"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectGroupElement = exports.getRadioButtonGroupElement = exports.getTextAreaInput = exports.getInputTextElement = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const text_area_1 = require("../custom-text-fields/text-area");
const disable_focus_wrapper_1 = require("../disable-focus-wrapper");
const radio_group_1 = require("./radio-group");
const select_group_1 = require("./select-group");
const text_helpers_1 = require("../helpers/text-helpers");
const RadioGroupWrapper = components_core_1.styled.div `
  color: #001e50;
  display: block;
`;
const RadioGroupLabelWrapper = components_core_1.styled.div `
  padding-bottom: 22px;
`;
const normalizeInput = (value) => {
    const currentValue = value;
    const cvLength = currentValue.length;
    if (cvLength < 4) {
        return currentValue;
    }
    if (cvLength < 7) {
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    }
    if (cvLength < 11) {
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
    }
    return;
};
const getInputTextElement = (properties, formikProps, isOptional) => {
    /**
     * Custom onchange for text input
     * @param event onchange event
     */
    const onChange = (event) => {
        const value = event.currentTarget.value;
        const onChageRegex = properties.regex;
        if (properties.name === 'phone') {
            const currentValue = value.replace(/[^\d]/gi, '');
            if (onChageRegex.test(currentValue)) {
                const formattedInput = normalizeInput(currentValue);
                formikProps.setFieldValue(properties.name, formattedInput, true);
            }
        }
        else {
            if (onChageRegex.test(value)) {
                formikProps.setFieldValue(properties.name, value, true);
            }
        }
    };
    const isErrorField = formikProps.touched[properties.name] && formikProps.errors[properties.name];
    return (react_1.default.createElement(components_core_1.Container, { key: properties.name, stretchContent: true },
        react_1.default.createElement(disable_focus_wrapper_1.DisableFocusWrapper, { style: { paddingBottom: "1px" }, className: 'disabled-focus-wrapper' },
            react_1.default.createElement(components_core_1.TextInput, { name: properties.name, placeholder: properties.placeholder, type: properties.type, value: formikProps.values[properties.name], onChange: onChange, onBlur: formikProps.handleBlur, appearance: properties.disabled
                    ? 'disabled'
                    : isErrorField
                        ? 'error'
                        : 'default', label: isOptional ? properties.optionalLabel : properties.label, defaultValue: formikProps.initialValues[properties.name], message: (isErrorField && formikProps.errors[properties.name]) ||
                    undefined, "data-testid": properties.name }))));
};
exports.getInputTextElement = getInputTextElement;
const getTextAreaInput = (properties, formikProps) => (react_1.default.createElement(components_core_1.Container, { key: properties.name, stretchContent: true },
    react_1.default.createElement(disable_focus_wrapper_1.DisableFocusWrapper, null,
        react_1.default.createElement(text_area_1.TextAreaCustom, { name: properties.name, placeholder: properties.placeholder, value: formikProps.values[properties.name], onChange: formikProps.handleChange, appearance: properties.disabled
                ? text_helpers_1.TextAreaAppearance.Disabled
                : formikProps.touched[properties.name] &&
                    formikProps.errors[properties.name]
                    ? text_helpers_1.TextAreaAppearance.Error
                    : text_helpers_1.TextAreaAppearance.Default, label: properties.label || '', errorText: formikProps.errors[properties.name], maxLength: properties.maxLenght, rows: properties.rows, maxRows: properties.maxRows }))));
exports.getTextAreaInput = getTextAreaInput;
const getRadioButtonGroupElement = (properties, formikProps) => (react_1.default.createElement(RadioGroupWrapper, { className: "radio-group" },
    react_1.default.createElement(RadioGroupLabelWrapper, { className: "radio-group-text" },
        react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.copy200, color: components_core_1.TokenTextColor.inherit }, properties.label)),
    react_1.default.createElement(radio_group_1.RadioButtonGroup, { fields: properties.fields || [], name: properties.name, onSelect: formikProps.setFieldValue, selectedValue: formikProps.values[properties.name] })));
exports.getRadioButtonGroupElement = getRadioButtonGroupElement;
const getSelectGroupElement = (masterSelect, slaveSelect, dropdownOption, formikProps) => {
    return (react_1.default.createElement(select_group_1.SelectGroup, { masterSelect: masterSelect, slaveSelect: slaveSelect, dropdownOption: dropdownOption, formikProps: formikProps }));
};
exports.getSelectGroupElement = getSelectGroupElement;
